export default __webpack_public_path__ + "images/005c303e40d1f1536546767165511df4-parenting_small.webp";